import React from "react";
import { Grid, GridCol } from "@mantine/core";
import CustomButton from "../../../components/CustomButton";
import { ReactComponent as StarIcon } from "../../../assets/Star.svg";
import { ReactComponent as ClockIcon } from "../../../assets/Clock Circle.svg";
import { ReactComponent as EarthIcon } from "../../../assets/Earth.svg";
import { ReactComponent as CupIcon } from "../../../assets/Cup.svg";
import { Link } from "react-router-dom";

const ClaimSection = () => {
  return (
    <div className="claim-section-wrapper ">
      <Grid className="inner-container desktop-wrapper">
        <GridCol span={{ base: 12, lg: 6 }}>
          <Grid>
            <GridCol span={{ base: 12, lg: 6 }}>
              <div
                className="claim-section-card"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <span>
                  <CupIcon />
                </span>
                <div className="text-wrapper">
                  <h5 className="cart-text">No win, no fee</h5>
                  <p className="cart-sub-text">
                    You only pay if we win your claim.
                  </p>
                </div>
              </div>
            </GridCol>
            <GridCol span={{ base: 12, lg: 6 }}>
              <div
                className="claim-section-card"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <span style={{ backgroundColor: "#799DD2" }}>
                  <StarIcon />
                </span>
                <div className="text-wrapper">
                  <h5 className="cart-text">Experienced experts</h5>
                  <p className="cart-sub-text">
                    A team dedicated to securing your rights.
                  </p>
                </div>
              </div>
            </GridCol>
            <GridCol span={{ base: 12, lg: 6 }}>
              <div
                className="claim-section-card"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <span style={{ backgroundColor: "#799DD2" }}>
                  <ClockIcon />
                </span>
                <div className="text-wrapper">
                  <h5 className="cart-text">Fast process</h5>
                  <p className="cart-sub-text">
                    Submit your claim in just a few minutes.
                  </p>
                </div>
              </div>
            </GridCol>
            <GridCol span={{ base: 12, lg: 6 }}>
              <div
                className="claim-section-card"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <span>
                  <EarthIcon />
                </span>
                <div className="text-wrapper">
                  <h5 className="cart-text">Global coverage</h5>
                  <p className="cart-sub-text">
                    We work with all major airlines worldwide.
                  </p>
                </div>
              </div>
            </GridCol>
          </Grid>
        </GridCol>
        <GridCol span={{ base: 12, lg: 6 }}>
          <div className="claim-section-right-wrapper">
            <h2 className="header">Trusted by travelers worldwide</h2>
            <p className="sub-header" style={{ width: "80%" }}>
              At Fly n’ Claim, we understand the frustration of disrupted
              travel. That’s why we make filing a claim simple and stress-free.
              Our team of legal experts specializes in airline compensation laws
              and handles the entire process for you. From filing your claim to
              negotiating with the airline, we do all the work while you focus
              on your next adventure.
            </p>
            <Link to={"/start-your-claim"} className="claim-btn-wrapper">
              <CustomButton btnText={"Start Your Claim Now"} />
            </Link>
          </div>
        </GridCol>
      </Grid>

      {/* Mobile View */}

      <Grid className="inner-container mobile-wrapper">
        <GridCol span={{ base: 12, lg: 6 }}>
          <div className="claim-section-right-wrapper">
            <h2 className="header">Trusted by travelers worldwide</h2>
            <p className="sub-header" style={{ width: "80%" }}>
              At Fly n’ Claim, we understand the frustration of disrupted
              travel. That’s why we make filing a claim simple and stress-free.
              Our team of legal experts specializes in airline compensation laws
              and handles the entire process for you. From filing your claim to
              negotiating with the airline, we do all the work while you focus
              on your next adventure.
            </p>
            <Link to={"/start-your-claim"} className="claim-btn-wrapper">
              <CustomButton btnText={"Start Your Claim Now"} />
            </Link>
          </div>
        </GridCol>
        <GridCol span={{ base: 12, lg: 6 }}>
          <Grid>
            <GridCol span={{ base: 12, lg: 6 }}>
              <div className="claim-section-card">
                <span>
                  <CupIcon />
                </span>
                <div className="text-wrapper">
                  <h5 className="cart-text">No win, no fee</h5>
                  <p className="cart-sub-text">
                    You only pay if we win your claim.
                  </p>
                </div>
              </div>
            </GridCol>
            <GridCol span={{ base: 12, lg: 6 }}>
              <div className="claim-section-card">
                <span style={{ backgroundColor: "#799DD2" }}>
                  <StarIcon />
                </span>
                <div className="text-wrapper">
                  <h5 className="cart-text">Experienced experts</h5>
                  <p className="cart-sub-text">
                    A team dedicated to securing your rights.
                  </p>
                </div>
              </div>
            </GridCol>
            <GridCol span={{ base: 12, lg: 6 }}>
              <div className="claim-section-card">
                <span style={{ backgroundColor: "#799DD2" }}>
                  <ClockIcon />
                </span>
                <div className="text-wrapper">
                  <h5 className="cart-text">Fast process</h5>
                  <p className="cart-sub-text">
                    Submit your claim in just a few minutes.
                  </p>
                </div>
              </div>
            </GridCol>
            <GridCol span={{ base: 12, lg: 6 }}>
              <div className="claim-section-card">
                <span>
                  <EarthIcon />
                </span>
                <div className="text-wrapper">
                  <h5 className="cart-text">Global coverage</h5>
                  <p className="cart-sub-text">
                    We work with all major airlines worldwide.
                  </p>
                </div>
              </div>
            </GridCol>
          </Grid>
        </GridCol>
      </Grid>
    </div>
  );
};

export default ClaimSection;
